import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function resourceHubReducer(
  state = initialState.ResourcesHubData,
  action
) {
  if (action.type === types.LOAD_RESOURCES_HUB_DATA_SUCCESS) {
    return action.ResourcesHubData;
  }
  return state;
}
